
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 6v17h2v1c0 2.21 1.79 4 4 4s4-1.79 4-4v-1h14V6H12v18c0 1.191-.809 2-2 2-1.191 0-2-.809-2-2v-1h2V6zm2 2h2v13H6zm8 0h12v13H14zm2 2v2h8v-2zm0 4v2h2v-2zm3 0v2h2v-2zm3 0v2h2v-2zm-6 3v2h2v-2zm3 0v2h2v-2zm3 0v2h2v-2z"}})])
          )
        }
      }
    